import { addYears, differenceInYears, parseISO } from "date-fns";
export const athleteBirthDateToAge = (athleteBirthdate) => {
    const today = new Date();
    const birthdate = parseISO(athleteBirthdate);
    return differenceInYears(today, birthdate);
};
export const maybeAthleteBirthDateToAge = (athleteBirthdate) => {
    if (athleteBirthdate === null)
        return null;
    return athleteBirthDateToAge(athleteBirthdate);
};
export const athleteAgeToApproxBirthDate = (age) => {
    const today = new Date();
    return addYears(today, -age);
};
export const getAthleteFullName = ({ firstName, lastName }) => `${firstName} ${lastName}`;
export const getAthleteListName = ({ firstName, lastName }) => `${lastName}, ${firstName}`;
//# sourceMappingURL=Athlete.js.map